import React from 'react';
import { testimonials } from '../data/pendingContent';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  const hasIllustrations = testimonials.some(t => t.image && t.imageIsIllustration);
  return <section aria-labelledby="testimonials-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-221" data-mp="3fycpzlihi3a9">
      <div className="max-w-6xl mx-auto" data-id="element-222" data-mp="3azt41l3w4rhw">
        <h2 id="testimonials-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-223" data-mp="36yzfcpimj8ny">
          Le vostre parole, le vostre creazioni
        </h2>

        <ul className="mt-10 columns-1 md:columns-2 lg:columns-3 gap-5" data-id="element-224" data-mp="321z665qh9psm">
          {testimonials.map(t => <li key={t.id} className="mb-5 break-inside-avoid" data-id="element-225" data-mp="2x2w50wdmc3px">
              <figure className="overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-soft" data-id="element-226" data-mp="2s309llizlklz">
                {t.image && <img src={t.image} alt={t.imageAlt ?? ''} loading="lazy" decoding="async" className="block aspect-[4/5] w-full object-cover" data-id="element-227" data-mp="v8ndvg960vl9" />}
                <div className={t.image ? 'px-6 pb-6 pt-5' : 'p-6 sm:p-7'} data-id="element-228" data-mp="h67xw01xbg89">
                  <blockquote className={`leading-relaxed text-ink ${t.image ? 'text-base' : 'font-serif text-lg sm:text-xl'}`} data-id="element-229" data-mp="h8ax9aoyulpn">
                    « {t.quote} »
                  </blockquote>
                  {t.name && <figcaption className="mt-4 text-sm" data-id="element-230" data-mp="c6vczkum4j8b">
                      <span className="font-semibold text-teal" data-id="element-231" data-mp="c7di76z967sd">{t.name}</span>
                      {t.context && <span className="text-ink/70" data-id="element-232" data-mp="zxqyy1ce0k7n"> · {t.context}</span>}
                    </figcaption>}
                </div>
              </figure>
            </li>)}
        </ul>

        {hasIllustrations}
      </div>
    </section>;
}